// extracted by mini-css-extract-plugin
module.exports = {"email":"RecoveryPasswordForm_email__s19k_","submitButton":"RecoveryPasswordForm_submitButton__ePNy1"};